export enum meetingDevicePreference {
    LAST_MIC_DEVICE = 'lastMicDevice',
    LAST_VIDEO_DEVICE = 'lastVideoDevice'
}